module.exports = __webpack_public_path__ + "media/images/integria-logo-dark-a4d420fc.png";